module.exports = __webpack_public_path__ + "efe1f400.svg";